import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { ListDealHistoryParams, ListDealHistoryResponse } from './types/deal'

export const dealHistoryApi = createApi({
	reducerPath: 'dealHistoryApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['DealHistory'],
	endpoints: (builder) => ({
		listDealHistory: builder.query<ListDealHistoryResponse, ListDealHistoryParams>({
			query: ({ dealId, ...params }) => ({
				url: `/crm/deals/${dealId}/history`,
				params,
			}),
			providesTags: (_r, _e, { dealId }) => [{ type: 'DealHistory', id: dealId }],
		}),
	}),
})

export const { useListDealHistoryQuery } = dealHistoryApi
